import { Typography } from '@mui/material';

import { Benefits } from 'modules/referralProgram/components/Benefits';
import { MarkdownWrapper } from 'modules/referralProgram/components/MarkdownWrapper';
import { ReferralProgram } from 'modules/strapi/types';
import { useAuth } from 'modules/auth/hooks/useAuth';
import { useTranslation } from 'modules/i18n/hooks/useTranslation';

import { promoGreetingTranslation } from './translation';

export interface PromoGreetingProps {
  referralProgram: ReferralProgram;
}

export const PromoGreeting = ({ referralProgram }: PromoGreetingProps) => {
  const { isLoggedIn } = useAuth();

  const { keys, t } = useTranslation(promoGreetingTranslation);

  const description = referralProgram.welcomeDialogDescription
    .replace('{name}', referralProgram.name)
    .replace(/\\n/g, '\n');

  const invitation = isLoggedIn
    ? t(keys.invitationToActivate)
    : t(keys.invitationToSignIn);

  // This is necessary to pass properties to the wrapper without typescript errors.
  const wrapperProps = { variant: 'body2' };

  return (
    <>
      <Typography variant="h6" sx={{ letterSpacing: '-0.03em' }}>
        {referralProgram.welcomeDialogTitle}
      </Typography>
      <MarkdownWrapper
        options={{
          wrapper: Typography,
          forceWrapper: true,
        }}
        {...wrapperProps}
      >
        {description}
      </MarkdownWrapper>
      <Benefits referralProgram={referralProgram} />
      <Typography variant="body2">{invitation}</Typography>
    </>
  );
};
